import classNames from "classnames";
import React, { CSSProperties, ReactElement, ReactNode } from "react";
import styles from "./panel.module.scss";

/**
 * @deprecated
 */
export const Panel = (props: Props): ReactElement => {
  const { className, ...rest } = props;
  return (
    <div className={classNames(props.className, styles["box"])} {...rest}>
      {props.children}
    </div>
  );
};

interface Props extends React.HTMLProps<HTMLDivElement> {
  style?: CSSProperties;
  children: ReactNode;
  className?: string;
}
